import React from "react";
import style from "./index.module.scss";
import { Popover } from "antd";
import { QuestionStatus } from "../../../../../service/question";

interface ListDropDownProps {
    id: number;
    status: QuestionStatus;
    onDelete: (id: number) => void;
    onSetting: (id: number) => void;
}

export default function ListDropDown({
    id,
    onSetting,
    onDelete
}: ListDropDownProps) {
    const popover = (
        <div className={style.popover}>
            <button onClick={() => onSetting(id)}>设置</button>
            <button onClick={() => onDelete(id)}>删除</button>
        </div>
    );
    return (
        <div className={style.root}>
            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}>
                <button className={style.more} />
            </Popover>
        </div>
    );
}
